import { useTranslations } from "next-intl";
import { Image } from "@components/core";

function GiftCardLayout({ children }) {
  const t = useTranslations("gift_cards");

  return (
    <div className="redeem-container">
      <Image
        src="giftCardActivateMobile"
        alt={t("redeem_alt")}
        className="w-100 d-md-none"
      />
      <Image
        src="giftCardActivateDesktop"
        alt={t("redeem_alt")}
        className="redeem-img-desktop d-none d-md-block"
      />
      <div className="redeem-content px-4 mx-auto">
        {children}
      </div>
    </div>
  );
}

export default GiftCardLayout;
